import { createFileRoute } from '@tanstack/react-router';
import OptionsRegistry from 'containers/OptionsRegistry';

export const Route = createFileRoute('/_authenticated/optionsRegistry')({
  component: OptionsRegistry,
});
